import React from 'react';
import useTheme from 'src/customizations/themes/hooks/useTheme';
import { renderNamedSlot } from 'src/utils/component';
import PressableArea from '../PressableArea';
const PageNavbarIcon = ({ Icon, style, onPress, to, ...iconProps }) => {
    const [{ theme }] = useTheme();
    return (React.createElement(PressableArea, { style: style, to: to, ...(onPress ? { onPress } : {}) }, renderNamedSlot(Icon, { size: theme.iconSize.md, ...iconProps })));
};
export default PageNavbarIcon;
